import { getApiAssets, getApiTags } from '../../config/pathURL/config';
import type { Tag, TagToAssetsMap } from '../../customerCenter/assetOverview/redux/types';
import { decodeJson, ignoreError, jsonOrReject, onRejected } from '../api';
import { getRequest } from '../requests';
import { type ApiAssetInfo, type ApiAssetInfoBody, ApiAssetInfoBodyCodec, ApiTagsCodec } from './tag.types';
import { mapAssetInfo, mapTags } from './tagMapper';

export function fetchTags(): Promise<Tag[]> {
    return fetch(`${getApiTags()}/tags`, getRequest())
        .then(jsonOrReject)
        .then(decodeJson(ApiTagsCodec))
        .then(mapTags)
        .catch(error => ignoreError(error, []));
}

const fetchAssetPage = (url: string): Promise<ApiAssetInfoBody> =>
    fetch(url, getRequest()).then(jsonOrReject).then(decodeJson(ApiAssetInfoBodyCodec));

async function fetchAllAssets(fetchPage = fetchAssetPage): Promise<ApiAssetInfo[]> {
    let page = await fetchPage(`${getApiAssets()}/assets?embed=(tags)&limit=1000`);
    let allItems = page.items;
    while (page._links?.next) {
        page = await fetchPage(page._links.next.href);
        allItems = allItems.concat(page.items);
    }
    return allItems;
}

export function fetchAssets(): Promise<ApiAssetInfo[]> {
    return fetchAllAssets().catch(onRejected());
}

export function fetchAssetInfo(): Promise<TagToAssetsMap> {
    const fetchPageIgnoringErrors = (url: string) =>
        fetchAssetPage(url).catch(error => ignoreError(error, { items: [] }));

    return fetchAllAssets(fetchPageIgnoringErrors)
        .then(mapAssetInfo)
        .catch(error => ignoreError(error, {}));
}
